<template>
  <div class="is-size-8">
    <table>
      <tr>
        <th class="has-text-left">
          {{$t('detailContrat.echeancier.tabEcheance.tooltip.type')}}
        </th>
        <th class="has-text-left">
          {{$t('detailContrat.echeancier.tabEcheance.tooltip.code')}}
        </th>
        <th class="has-text-left">
          {{$t('detailContrat.echeancier.tabEcheance.tooltip.etat')}}
        </th>
        <th class="has-text-left">
          {{$t('detailContrat.echeancier.tabEcheance.tooltip.montant')}}
        </th>
      </tr>
      <tr v-for="(facture, index) in commande.factures" :key="index">
        <td class="has-text-left">
          {{getSousTypeLibelle(facture.sousType)}}
        </td>
        <td class="has-text-left">
          {{facture.code}}
        </td>
        <td class="has-text-left">
          {{getEtatLibelle(facture.etat)}}
        </td>
        <td class="has-text-rigth">
          {{facture.montantTtc| formatDevise }}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>

import { FACTURE_SOUS_TYPE, FACTURE_ETAT } from '@/configuration/facture/factureConf';

export default {
  name: 'echeanceFacturesTable',
  props: {
    commande: {
      type: Object,
      required: true,
    },
  },
  computed: {

  },
  methods: {
    getSousTypeLibelle(type) {
      return this.$t(FACTURE_SOUS_TYPE.find(st => st.code === type).libelle);
    },
    getEtatLibelle(etat) {
      return this.$t(FACTURE_ETAT.find(st => st.code === etat).libelle);
    },
  },
  mounted() {
  },
};
</script>
